<template>
  <div class="tw-py-4 tw-px-6 tw-flex tw-flex-col tw-gap-4">
    <template v-for="comm in items" :key="`${comm.kind}-${comm.id}`">
      <RemarkV2
        v-if="comm.kind === 'remark-card'"
        :remark="comm"
        show-context-btn
        show-context
        show-tags
        part-of="inbox"
      />
      <NotificationContent v-else type="CheckList" :communication-item="comm" />
    </template>
    <div
      class="
        tw-mx-auto
        tw-my-4
        tw-font-medium
        tw-text-sm
        tw-text-sf-gray-light
        tw-text-center
      "
    >
      {{ I18n.t('communication.messages.no_more_messages') }}
    </div>
  </div>
</template>

<script setup>
import RemarkV2 from '@app/shared/vue/components/molecules/remark-v2/remark-v2.vue'
import NotificationContent from '@app/application/communication/screens/inbox/components/notification-content.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

const I18n = useI18n()

defineProps({
  items: {
    type: Array,
    required: true,
  },
})
</script>
